import { render } from "./ReviewRequestPage.vue?vue&type=template&id=27d0a088&scoped=true&ts=true"
import script from "./ReviewRequestPage.vue?vue&type=script&lang=ts"
export * from "./ReviewRequestPage.vue?vue&type=script&lang=ts"

import "./ReviewRequestPage.vue?vue&type=style&index=0&id=27d0a088&scoped=true&lang=css"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d0a088"]])

export default __exports__